<form [formGroup]="formGroup" class="flex gap-4">
  <em-input
    formControlName="find"
    [label]="'SHARED_LABEL_FIND' | translate"
    floatLabel="always"
    subscriptSizing="dynamic"
  >
    <em-icon name="search" emPrefix></em-icon>
  </em-input>
  <em-input
    formControlName="replace"
    [label]="'SHARED_LABEL_REPLACE_WITH' | translate"
    floatLabel="always"
    subscriptSizing="dynamic"
  >
    <em-icon name="swap_horiz" emPrefix></em-icon
  ></em-input>
</form>
